import { HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { ProvidehttpService } from "./providehttp.service";
import { RetailStock } from "./retail-common.service";

@Injectable({
  providedIn: "root",
})
export class AccountOnboarding {
  isRegistration: boolean = false;
  draftData: any = {};
  customerData: any = {};
  otherData: any = {};
  currentStage: string = "AccJointUser";
  completedStage: number = -1;
  stages: any = ["AccJointUser", "citizenshipScreen", "TaxinfoSample1", "mobileTan", "CreditSummary"];
  stageLbl:any = ["", "citizenship details", "tax information", "mobile tan", "account summary"];

  isApplicationDataAvailable:boolean = false;
  isEntrolmentDoneUptoIDNow:boolean = false;

  constructor(private http: ProvidehttpService, private router: Router, private retailStock:RetailStock) {}

  startOnboarding() {
    this.draftData = {};
    this.customerData = {};
    this.otherData = {};
    this.currentStage = "AccJointUser";
    this.completedStage = -1;
    let inputMap = new Map();
    inputMap.clear();
    inputMap.set("PathParam.userId", sessionStorage.getItem("customerCode"));
    this.http.fetchApi("/customer/{userId}", "GET", inputMap, this.retailStock.getEnvironment().customersPublisher).subscribe(
      async (httpResponse: HttpResponse<any>) => {
        var res = httpResponse.body;
        this.customerData = res;
        this.customerData["personalDetails"]["placeOfBirth"] = this.customerData["addressDetails"]["pob"];
        /*SANTHOSH 19/09/2021 BEGIN*/
        let livingSince = this.customerData["addressDetails"]["livingSince"];
        let livingSinceComponents = livingSince.split("-");
        if (parseInt(livingSinceComponents[1]) < 10) {
          livingSinceComponents[1] = "0" + livingSinceComponents[1];
        }
        this.customerData["addressDetails"]["livingSince"] = livingSinceComponents[1] + "-" + livingSinceComponents[0];
        /*SANTHOSH 19/09/2021 END*/
        this.otherData["productCode"] = "750";
        this.otherData["accountCurrency"] = "EUR";
        this.otherData["moveAccount"] = "Y";
        this.otherData["salaryFlag"] = "Y";
        this.otherData["directDebitFlag"] = "N";
        inputMap.clear();
        inputMap.set("PathParam.countryCode", this.customerData["personalDetails"]["citizenship"]);
        this.http.fetchApi("/country/{countryCode}", "GET", inputMap, this.retailStock.getEnvironment().commonPublisher).subscribe(
          async (httpResponse: HttpResponse<any>) => {
            var res = httpResponse.body;
            this.otherData["IsEUCustomer"] = res["country"]["intnlZoneCode"] == "EU";

            //navigation to account onboarding process
            this.router.navigate(["/newAccountOpening"]);
          },
          async (httpError) => {
            var err = httpError["error"];
            if (err != null && err["ErrorElementPath"] != undefined && err["ErrorDescription"] != undefined) {
            }
          }
        );
      },
      async (httpError) => {
        var err = httpError["error"];
        if (err != null && err["ErrorElementPath"] != undefined && err["ErrorDescription"] != undefined) {
        }
      }
    );
  }

  loadProductInfo(callback) {
    let inputMap = new Map();
    inputMap.clear();
    inputMap.set("PathParam.userId", sessionStorage.getItem("customerCode"));
    this.http.fetchApi("/products/{userId}", "GET", inputMap, this.retailStock.getEnvironment().customersPublisher).subscribe(
      async (httpResponse: HttpResponse<any>) => {
        var res = httpResponse.body;
        callback(res);
      },
      async (httpError) => {
        var err = httpError["error"];
        if (err != null && err["ErrorElementPath"] != undefined && err["ErrorDescription"] != undefined) {
        }
      }
    );
  }

  cancelOnboarding() {
    this.router.navigate(["/home/openAccount"]);
  }

  setDraftData(key, data) {
    this.draftData[key] = data;
    this.draftData["currentStage"] = key;
  }

  getDraftData() {
    this.draftData["customerCode"] = sessionStorage.getItem("customerCode");
    let jsonString = JSON.stringify(this.draftData);
    return jsonString;
  }

  updateDraftData(stage, data) {
    this.draftData[stage] = data;
  }
  /*SANTHOSH 13/09/2021 BEGIN*/
  downloadFile() {
    let inputMap = new Map();
    inputMap.clear();
    return this.http.fetchFileApi("/Contract", inputMap, this.retailStock.getEnvironment().accountsPublisher);
  }
  /*SANTHOSH 13/09/2021 END*/
  saveAsDraft() {
    let inputMap = new Map();
    inputMap.clear();
    inputMap.set("PathParam.draftType", "AT");
    inputMap.set("PathParam.userId", sessionStorage.getItem("customerCode"));
    inputMap.set("Body.userdraft.draftContent", this.getDraftData());
    this.http.fetchApi("/userdraft/{userId}/{draftType}", "PUT", inputMap, this.retailStock.getEnvironment().commonPublisher).subscribe(
      async (httpResponse: HttpResponse<any>) => {
        var res = httpResponse.body;
      },
      async (httpError) => {
        var err = httpError["error"];
        if (err != null && err["ErrorElementPath"] != undefined && err["ErrorDescription"] != undefined) {
        }
      }
    );
  }

  fetchDraftData(callback:any){
    let inputMap = new Map();
    inputMap.clear();
    inputMap.set("PathParam.userId", sessionStorage.getItem("customerCode"));
    inputMap.set("PathParam.draftType", "AT");
    this.http.fetchApi("/userdraft/{userId}/{draftType}", "GET", inputMap, this.retailStock.getEnvironment().commonPublisher).subscribe(
      async (httpResponse: HttpResponse<any>) => {
        var res = httpResponse.body;
        if(res){
          this.draftData = JSON.parse(res["userdraft"]["draftContent"]);
          this.draftData["customerCode"] = sessionStorage.getItem("customerCode");

          if(this.draftData["otherData"]){
            this.otherData["riskGradingColour"] = this.draftData.otherData["riskGradingColour"];
          }
          
          this.currentStage = this.draftData.currentStage;
          let i = this.stages.indexOf(this.currentStage);
          this.completedStage = i;
          if(this.currentStage == "mobileTan" && this.draftData["mobileTan"]["requiredAction"] == "idnow"){
            this.isEntrolmentDoneUptoIDNow = true;
          }
          this.isApplicationDataAvailable = true;
        }else{
          this.isApplicationDataAvailable = false;
        }

        this.loadPrerequestData(callback);
      },
      async (httpError) => {
        var err = httpError["error"];
        if (err != null && err["ErrorElementPath"] != undefined && err["ErrorDescription"] != undefined) {
        }
        this.isApplicationDataAvailable = false;
        callback();
      }
    );
  }

  loadPrerequestData(callback){
    let inputMap = new Map();
    inputMap.clear();
    inputMap.set("PathParam.userId", sessionStorage.getItem("customerCode"));
    this.http.fetchApi("/customer/{userId}", "GET", inputMap, this.retailStock.getEnvironment().customersPublisher).subscribe(
      async (httpResponse: HttpResponse<any>) => {
        var res = httpResponse.body;
        this.customerData = res;
        this.customerData["personalDetails"]["placeOfBirth"] = this.customerData["addressDetails"]["pob"];
        /*SANTHOSH 19/09/2021 BEGIN*/
        let livingSince = this.customerData["addressDetails"]["livingSince"];
        let livingSinceComponents = livingSince.split("-");
        if (parseInt(livingSinceComponents[1]) < 10) {
          livingSinceComponents[1] = "0" + livingSinceComponents[1];
        }
        this.customerData["addressDetails"]["livingSince"] = livingSinceComponents[1] + "-" + livingSinceComponents[0];
        /*SANTHOSH 19/09/2021 END*/
        this.otherData["productCode"] = "750";
        this.otherData["accountCurrency"] = "EUR";
        this.otherData["moveAccount"] = "Y";
        this.otherData["salaryFlag"] = "Y";
        this.otherData["directDebitFlag"] = "N";

        inputMap.clear();
        inputMap.set("PathParam.countryCode", this.customerData["personalDetails"]["citizenship"]);
        this.http.fetchApi("/country/{countryCode}", "GET", inputMap, this.retailStock.getEnvironment().commonPublisher).subscribe(
          async (httpResponse: HttpResponse<any>) => {
            var res = httpResponse.body;
            this.otherData["IsEUCustomer"] = res["country"]["intnlZoneCode"] == "EU";
            callback();
          },
          async (httpError) => {
            var err = httpError["error"];
            if (err != null && err["ErrorElementPath"] != undefined && err["ErrorDescription"] != undefined) {
            }
            callback();
          }
        );
      },
      async (httpError) => {
        var err = httpError["error"];
        if (err != null && err["ErrorElementPath"] != undefined && err["ErrorDescription"] != undefined) {
        }
      }
    );
  }

  loadFromDraft() {
    let inputMap = new Map();
    inputMap.clear();
    inputMap.set("PathParam.userId", sessionStorage.getItem("customerCode"));
    inputMap.set("PathParam.draftType", "AT");
    this.http.fetchApi("/userdraft/{userId}/{draftType}", "GET", inputMap, this.retailStock.getEnvironment().commonPublisher).subscribe(
      async (httpResponse: HttpResponse<any>) => {
        var res = httpResponse.body;
        this.draftData = JSON.parse(res["userdraft"]["draftContent"]);
        this.draftData["customerCode"] = sessionStorage.getItem("customerCode");
        this.currentStage = this.draftData.currentStage;

        let i = this.stages.indexOf(this.currentStage);
        this.completedStage = i;

        if (this.currentStage != "country") {
          this.isRegistration = true;
          this.router.navigate(["/newAccountOpening/" + this.currentStage]);
        }
      },
      async (httpError) => {
        var err = httpError["error"];
        if (err != null && err["ErrorElementPath"] != undefined && err["ErrorDescription"] != undefined) {
        }
      }
    );
  }

  getNextStage() {
    let stage = "";
    if (this.draftData && this.draftData.currentStage) {
      let i = this.stages.indexOf(this.draftData.currentStage);
      this.completedStage = i;
      this.currentStage = this.stages[i + 1];
      stage = this.stages[i + 1];
      if (!stage) {
        this.currentStage = "acobSummary";
        stage = "acobSummary";
      }
    }
    return stage;
  }

  createNewAccount(callback) {
    let data = {};

    data["customerId"] = sessionStorage.getItem("customerCode");
    data["deviceId"] = sessionStorage.getItem("deviceId");
    data["productDetails"] = {};
    data["productDetails"]["riskGradingColour"] = this.otherData["riskGradingColour"];
    data["productDetails"]["productCode"] = this.otherData["productCode"];
    data["productDetails"]["accountCurrency"] = this.otherData["accountCurrency"];
    data["productDetails"]["moveAccount"] = this.otherData["moveAccount"];
    data["productDetails"]["salaryFlag"] = this.otherData["salaryFlag"];
    data["productDetails"]["directDebitFlag"] = this.otherData["directDebitFlag"];
    data["productDetails"]["income"] = this.draftData["TaxinfoSample1"]["salaryAmount"];

    data["personalDetails"] = {};
    data["personalDetails"]["firstName"] = this.customerData["personalDetails"]["firstName"];
    data["personalDetails"]["lastName"] = this.customerData["personalDetails"]["lastName"];

    data["addressDetails"] = {};
    data["addressDetails"]["street"] = this.customerData["addressDetails"]["street"];
    data["addressDetails"]["addressComp"] = this.customerData["addressDetails"]["addressComp"];
    data["addressDetails"]["city"] = this.customerData["addressDetails"]["city"];

    let inputMap = new Map();
    inputMap.clear();
    inputMap.set("Body", data);
    this.http.fetchApi("/account", "POST", inputMap, this.retailStock.getEnvironment().customersPublisher).subscribe(
      async (httpResponse: HttpResponse<any>) => {
        var res = httpResponse.body;
        this.otherData["limitReferenceNumber"] = res["limitReferenceNumber"];
        this.otherData["limitAmount"] = res["limitAmount"] ? res["limitAmount"] : "0.00";
        this.otherData["accountNumber"] = res["accountNumber"];
        this.currentStage = "SummaryProducts";
        callback();
        this.router.navigate(["/newAccountOpening/SummaryProducts"]);
      },
      async (httpError) => {
        var err = httpError["error"];
        if (err != null && err["ErrorElementPath"] != undefined && err["ErrorDescription"] != undefined) {
          callback();
        }
      }
    );
  }

  getPreviousStage(currentStage) {
    let stage = "";
    let i = this.stages.indexOf(currentStage);
    stage = this.stages[i - 1];
    if (i - 1 == -1) {
      stage = "AccJointUser";
    }
    return stage;
  }

  gotoStage(stage) {
    this.router.navigate(["/newAccountOpening/" + stage]);
  }

  setReadonlyFieldSet(fieldSetId, enable: boolean = true) {
    let fieldSetEl = document.getElementById(fieldSetId).querySelector(".field-set");
    if (enable == true) {
      fieldSetEl.classList.add("read-only");
    } else {
      fieldSetEl.classList.remove("read-only");
    }
  }

  enableFieldSet(fieldSetId, enable: boolean = true) {
    let fieldSetEl = document.getElementById(fieldSetId).querySelector(".field-set");
    if (enable == true) {
      fieldSetEl.classList.remove("preview-mode");
    } else {
      fieldSetEl.classList.add("preview-mode");
    }
  }

  storePIN(pin) {
    //localStorage.setItem("pin", pin);
    //this.services.dataStore.storePIN(pin);
  }

  deleteDraft(callback){
    let inputMap = new Map();
    inputMap.clear();
    inputMap.set("PathParam.userId", sessionStorage.getItem("customerCode"));
    inputMap.set("PathParam.draftType", "AT");
    this.http.fetchApi("/userdraft/{userId}/{draftType}", "DELETE", inputMap, this.retailStock.getEnvironment().commonPublisher).subscribe(
      async (httpResponse: HttpResponse<any>) => {
        console.log("draft deleted");
        this.draftData = {};
        this.customerData = {};
        this.otherData = {};
        this.currentStage = "AccJointUser";
        this.completedStage = -1;
        callback();
      },
      async (httpError) => {
        var err = httpError["error"];
        if (err != null && err["ErrorElementPath"] != undefined && err["ErrorDescription"] != undefined) {
        }
      }
    );
  }

}
